export default __webpack_public_path__ + "static/media/wallet.4c17a726.png";